const { FIELD_TYPES } = require('@wix/dbsm-common/src/collections/consts')

module.exports = (fieldType, value) =>
  fieldType
    .map(type => {
      if (
        type === FIELD_TYPES.NUMBER &&
        typeof value === 'string' &&
        /^[+-]?((\d+\.?\d*)|(\d*\.?\d+))$/.test(value.trim())
      ) {
        return Number(value)
      }

      return value
    })
    .getOrElse(value)
